import manifestManager from "flow/utils/manifestManager";
import config from "flow/config";
import viewCache from "flow/utils/viewCache";
import MyFlow from "flow/MyFlow";
import * as homeConfiguration from "flow/stores/homeConfiguration";
import "flow/viewModels/HomeConfigurationDialog";

// I create my own manifest
manifestManager.addManifests(config.moduleId, [
    {
        id: config.componentIds.homeContext,
        isWorkingContext: true,
        namespace: "default",
        reuseInstance: true,
        viewModelId: "flow/viewModels/HomeContext",
        viewUrl: "virtual/HomeContext"
    }
]);

viewCache.inject("virtual/HomeContext", "");

export default class HomeContext {
    private componentIds: string[] = [];
    constructor(private readonly myFlow: MyFlow) {
        myFlow.subscribe(config.topics.homescreenRequestUpdate, () => {
            this.updateHomeScreen();
        });
    }

    activate(_viewContext: any, containerId: string) {
        const homeScreenManifests: any[] = manifestManager.getHomeScreenManifests();
        homeScreenManifests.forEach(manifest => {
            this.componentIds.push(manifest.id);

            if (!homeConfiguration.isHidden(manifest.id)) {
                this.myFlow.activateById(manifest.id);
            }
        });

        if (containerId) {
            this.myFlow.selectById(containerId, undefined, true);
        } else {
            this.myFlow.selectFirst();
        }
    }

    shouldBeVisible(componentId: string) {
        const manifest = manifestManager.getManifestWithId(componentId);
        if (manifest === undefined || manifest === null) return false;
        return manifest.isVisibleOnHomeScreen === true;
    }

    configureHome() {
        this.myFlow.showCustomDialog(config.componentIds.homeConfiguration).then((updated: boolean) => {
            if (!updated) {
                return;
            }

            this.updateHomeScreen();
        });
    }

    updateHomeScreen() {
        const hideList: string[] = [];
        const showList: string[] = [];

        this.componentIds.forEach(id => {
            if (homeConfiguration.isHidden(id)) {
                hideList.push(id);
            } else {
                showList.push(id);
            }
        });

        hideList.forEach(id => {
            if (this.myFlow.isComponentActive(id)) {
                this.myFlow.deactivateById(id);
            }
        });

        showList.forEach(id => {
            if (!this.myFlow.isComponentActive(id)) {
                this.myFlow.activateById(id);
            }
        });

        this.myFlow.publish(config.topics.homescreenUpdated);
    }
}
